import { ModuleWithProviders, NgModule } from '@angular/core';
import { EndpointsConfigGuard } from './guards/endpoints-config.guard';
import { EndpointsConfigService } from './services/endpoints-config.service';
import { ENDPOINTS_CONFIG } from './models/endpoints-config';

@NgModule({
    providers: [EndpointsConfigGuard]
})
export class EndpointsConfigModule {
    static forRoot(): ModuleWithProviders<EndpointsConfigModule> {
        return {
            ngModule: EndpointsConfigModule,
            providers: [
                EndpointsConfigService,
                EndpointsConfigGuard
            ]
        };
    }

    static forChild(): ModuleWithProviders<EndpointsConfigModule> {
        return {
            ngModule: EndpointsConfigModule,
            providers: [{
                provide: ENDPOINTS_CONFIG,
                useFactory: (configService: EndpointsConfigService) => configService.getEndpointsConfig(),
                deps: [EndpointsConfigService]
            }]
        };
    }
}
